import { ProductionSite } from "../api"
import { LocalStorageInstance } from "./LocalStorageService"

export interface ProductionSiteInfo extends ProductionSite {
    description: string
}

export const exceptionalProductionSiteNames = {
    Missing: '?',
    Studenten: 'FRZ',
    ToBeDetermined: 'TBD'
}

const missingProductionSite: ProductionSiteInfo = {
    code: exceptionalProductionSiteNames.Missing,
    name: 'no production site found',
    isActive: false,
    supportsAddressChange: false,
    supportsProductionNotification: false,
    description: 'no production site found'
}

const tbdProductionSite: ProductionSiteInfo = {
    code: exceptionalProductionSiteNames.ToBeDetermined,
    name: "To Be Determined",
    isActive: false,
    supportsAddressChange: true,
    supportsProductionNotification: false,
    description: "To Be Determined"
}

const studentenProductionSite: ProductionSiteInfo = {
    code: exceptionalProductionSiteNames.Studenten,
    name: "Studenten production site",
    isActive: false,
    supportsAddressChange: false,
    supportsProductionNotification: false,
    description: "Studenten production site"
}

const unknownProductionSiteTemplate: ProductionSiteInfo = {
    code: '',
    name: 'Unknown production site',
    isActive: false,
    supportsAddressChange: false,
    supportsProductionNotification: false,
    description: ''
}

class ProductionSiteInstance {
    getProductionSiteInfo(code: string | undefined): ProductionSiteInfo {
        if (code === undefined || code === '') {
            return missingProductionSite
        }
        if (code.toLocaleUpperCase() === exceptionalProductionSiteNames.ToBeDetermined) {
            return tbdProductionSite
        }
        if (code.toLocaleUpperCase() === exceptionalProductionSiteNames.Studenten) {
            return studentenProductionSite
        }
        const config = LocalStorageInstance.getGlobalConfiguration()
        const site = config?.productionSites.find((site) => site.code.toLocaleUpperCase() === code.toLocaleUpperCase())
        if (site) {
            return {
                ...site,
                description: `${site.isActive ? '' : "InActive: "}${site.name}`,
            } as ProductionSiteInfo
        }
        return {
            ...unknownProductionSiteTemplate,
            code: code,
            description: `Unknown production site ${code}`
        } as ProductionSiteInfo
    }

    getActiveProductionSites(): ProductionSite[] {
        const config = LocalStorageInstance.getGlobalConfiguration()
        return (config?.productionSites ?? [])
            .filter((site) => site.isActive)
            .sort((a, b) => a.code.localeCompare(b.code))
    }
}
export const ProductionSiteServiceInstance = new ProductionSiteInstance()